export default __webpack_public_path__ + "static/img_interviewee_okwon-1426c4f06fcd7988533577fd05e60364.png";